/**
 * 断言工具 - Fail-Fast 原则
 * 用于立即失败，快速定位根因
 */

/**
 * 生产环境断言 - 在所有环境下都会检查
 * @param cond 条件表达式
 * @param msg 错误消息
 */
export function invariant(cond: unknown, msg: string): asserts cond {
  if (!cond) {
    throw new Error(`[Invariant] ${msg}`)
  }
}

/**
 * 开发环境断言 - 仅在开发环境检查，生产环境零开销
 * 用于检查数据/权限/参数就绪等开发时需要验证的条件
 *
 * @param cond 条件表达式
 * @param msg 错误消息
 *
 * @example
 * ```typescript
 * // 检查必需数据
 * const route = useRoute();
 * invariantDev(typeof route.params.taskId === 'string', 'taskId missing');
 *
 * // 检查用户状态
 * const { currentUser } = storeToRefs(useUserStore());
 * invariantDev(!!currentUser.value, 'user not loaded yet');
 *
 * // 检查配额
 * invariantDev(quotaRemaining > 0, 'quota exhausted');
 *
 * // 检查输入
 * invariantDev(text.length <= 5000, 'text too long');
 * ```
 */
export function invariantDev(cond: unknown, msg: string): asserts cond {
  // 生产环境直接返回，零开销
  if (!import.meta.env.DEV) return;

  if (!cond) {
    throw new Error(`[InvariantDev] ${msg}`)
  }
}
